// extracted by mini-css-extract-plugin
module.exports = {"protocol":"index_protocol__1Hkw7","title":"index_title__oTNol","bold":"index_bold__3RCpV","header":"index_header__puKW2","protocolBox":"index_protocolBox__35aX6"};